import React, { useEffect, useRef, useState } from 'react';
import { Protected } from '@components/layout/Protected';
import { Loading } from "@components/common/Loading";
import { Props } from './BranchOffices.type'
import { Alert, Backdrop, CircularProgress, Container, Divider, Grid, IconButton, Menu, MenuItem, Snackbar } from "@mui/material";
import { TableDataV2 } from '@/components/common/Tablev2';
import { branchOfficeRepository } from '@/service/repositories/BranchOffice.repository';
import { ModalBranchOffice } from '@/components/Modal/ModalBranchOffice';
import { ModalBranchOfficeDelete } from '@/components/Modal/ModalBranchOfficeDelete';


export const BranchOfficeView: React.FC<Props> = (props:any): JSX.Element => {

   const [loading, setLoading] = useState<boolean>(false);
   const [branchOffices, setBranchOffices] = useState<any>([]);
   const [showBranchOfficeModal, setShowBranchOfficeModal] = useState<boolean>(false);
   const [showBranchDeleteModal, setShowBranchDeleteModal] = useState<boolean>(false);
   const [actionSelected, setActionSelected] = useState<any>('');
   const [branchOfficeSelected, setBranchOfficeSelected] = useState<any>('');

   useEffect(() => {
      getBranchOffices()
   },[]);

   const getBranchOffices = async () => {
      setLoading(true);
      const response = await branchOfficeRepository.getBranchOffices();
      if (response.data) {
         setBranchOffices(response.data || [])
      } else {
      console.log('error')
      }
      setLoading(false);
   }

   function RecuperarData(value){
      console.log(value);
      setBranchOfficeSelected(value);
   }

  return (
      <Protected>
         {loading && <Loading/>}

         <Container>
            <TableDataV2
               title={'Sucursales'}
               data={branchOffices}
               header={[
                  { name: 'code', label: 'Codigo', filter: false, Chip: false },
                  { name: 'address', label: 'Direccion', filter: false, Chip: true },
                  { name: 'phone', label: 'Telefono', filter: false, Chip: false },
               ]}
               actionSelect={setActionSelected}
               setModalSave={setShowBranchOfficeModal}
               setModalDelete={setShowBranchDeleteModal}
               status_action
               RecuperarData={RecuperarData}
            />
         </Container>

         { 
            showBranchOfficeModal && (
               <ModalBranchOffice
                  open={showBranchOfficeModal}
                  closeModal={()=>{setShowBranchOfficeModal(false)}}
                  actionSelected={actionSelected}
                  onListBranchOffices={getBranchOffices}
                  branchOffice={branchOfficeSelected}
                  clearState={()=>{setBranchOfficeSelected('')}}
               />
            )
         }
         {
            actionSelected === 'delete' && (
               <ModalBranchOfficeDelete
                  open={showBranchDeleteModal}
                  closeModal={()=>{setShowBranchDeleteModal(false)}}
                  actionSelected={actionSelected}
                  onListBranchOffices={getBranchOffices}
                  branchOffice={branchOfficeSelected}
                  clearState={()=>{setBranchOfficeSelected('')}}
               />
            )
         }
      
      </Protected>
   )
};